module.exports = new __parcel__URL__("damagebuff.0d0c9c55.png").toString();